import React from 'react';
import PropTypes from 'prop-types';

const Tag = ({name}) => {
    if (!name) return null;
    return <li className="tw-bg-lightBlue tw-px-2 tw-py-1 tw-text-sm dark:tw-bg-neonYellow dark:tw-text-veryBlack">{name}</li>;
};

Tag.propTypes = {
    name: PropTypes.string.isRequired,
};

export default Tag;
